<app-header></app-header>
<p-breadcrumb  class="max-w-full" [model]="routernames" [home]="home" ></p-breadcrumb>
<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "line-spin-fade" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
